import React, { useCallback, useState } from 'react'
import UserIcon from './../../assets/img/icon/user-circle.svg'
import UserProfileMenu from '../userprofilemenu/UserProfileMenu';
import './style.css'


function UserProfile({ setShowSideBar, showSideBar}) {

const openModal = useCallback(() => {
  setShowSideBar(!showSideBar)
}, [!showSideBar]); 


  return (
    <>
    {
      !showSideBar ? <UserProfileMenu /> : null
    }
    <div className='user-profile'>
      <img src={UserIcon} onChange={openModal}  />
    </div>
    
    </>
    
  )
}

export default UserProfile;